module.exports = __webpack_public_path__ + "static/media/image-card-4.54a6a619.png";